import {
    Controller,
    Flash,
    Helper,
    Instance,
    Knot,
    ProgressStatus,
    State,
} from '@siposdani87/sui-js';
import { app } from '../app';

import { LanguageService } from '@services/languageService';
import { OrderService } from '@services/orderService';

export class OrdersRejectController extends Controller {
    static readonly inject = [
        'instances',
        'orderService',
        'languageService',
    ] as const;

    private helper: Helper;
    private state: State;
    private dom: Knot;
    private flash: Flash;

    constructor(
        instances: Instance,
        private orderService: OrderService,
        private languageService: LanguageService,
    ) {
        super();

        this.helper = instances.helper;
        this.state = instances.state;
        this.dom = instances.dom;
        this.flash = instances.flash;
    }

    enter(): void {
        this._initLayout();
    }

    protected _initLayout(): void {
        this._initToolbarButtons();
        this._initPayment();
    }

    private _initToolbarButtons(): void {
        this.helper.fabButton(
            '.btn-orders-new',
            this.dom,
            () => {
                this.state.go('orders.new');
            },
            '',
            true,
            [],
        );
    }

    private _initPayment(): void {
        const paymentParams = this.state.getParams();
        const progressStatus = new ProgressStatus(this.dom);
        this.orderService.reject(paymentParams).then(
            (response) => {
                this.flash.addMessage(response.get('message'));
                progressStatus.setInfo(
                    this.languageService.translate(
                        'orders_controller.reject.success',
                    ),
                    'info',
                );
                setTimeout(() => {
                    this.state.go('orders.new');
                }, 2000);
            },
            (response) => {
                this.flash.addMessage(response.get('message'));
                progressStatus.setError(
                    this.languageService.translate(
                        'orders_controller.reject.fail',
                    ),
                    'close',
                );
            },
        );
    }
}

export const ordersRejectController = app.controller(
    'ordersRejectController',
    OrdersRejectController,
);
